import { getDefaultShopConfig } from './default';
import { getConditionsFilterConfig } from '../filters/condition';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfig } from '../filters/size';
import { getColorFilterConfig } from '../filters/color';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { BuilderSections } from '../../util/builder';

const sizes = [
  'XSmall',
  'Small',
  'Medium',
  'Luxe',
  '1Luxe',
  '2Luxe',
  '3Luxe',
  '4Luxe',
  '5Luxe',
  '6Luxe',
];

export const shefitShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes }),
    getColorFilterConfig(),
    getBrandDirectFilterConfig(),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: 'c752804bee3d4b8db7f74f6a13edf730',
    },
  },
};
